<template>
  <div
    class="box-list"
    :style="{ 'border-left': `15px solid ${plan.backgroundColor}` }"
    @click="openVisitDetail(plan.customerID, plan.visitID)"
  >
    <div class="col-12 d-flex">
      <div>
        <img :src="plan.image" class="icon-picture" />
      </div>
      <div class="col-4 d-flex flex-column textoverflow">
        <span class="font-w-600">{{ plan.title }}</span>
        <base-icon-site
          :data-type="plan.typeName"
          font-size="17"
          icon-size="30"
        />
      </div>
      <div class="col-3 px-1 text-center">
        <base-icon-pin
          :data-distance="plan.distance"
          font-size="17"
          icon-size="30"
        />
      </div>
      <div class="col-3 px-0 text-center">
        <btn-visit-status
          :message="plan.statusName"
          :backgroundColor="plan.backgroundColor"
          :textColor="plan.textColor"
        />
      </div>
      <div class="col-1">
        <img src="/img/icons/dropdown_right.svg" class="icon-image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    plan: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    openVisitDetail(customerId, visitId) {
      this.$router.push({ path: `/visitdetail/${customerId}/${visitId}` })
    },
  },
}
</script>

<style lang="scss" scoped>
.box-list {
  // padding: 15px;
  margin: 15px 0px;
  border-radius: 8px;
  height: 90px;
  background: white;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 15%);
  -webkit-box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 15%);
}

.icon-picture {
  width: 55px;
  height: 55px;
  border-radius: 50%;
}

.icon-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
